import React, { useEffect, useState } from 'react'
import { View } from 'react-native'
import { ListItem } from '../molecules'
import { theme } from '@linqpal/common-frontend'
import { ButtonFlowNext } from '../molecules/ButtonFlowNext'
import { InputText } from '@linqpal/common-frontend/src/ui'

const { commonColors } = theme

export const FormInputSelectAndNavigate = ({
  onValue,
  currentData,
  data,
  options = ['Yes', 'No'],
  document,
  onValueForCoOwner,
  identifier,
  otherTextLabel,
}) => {
  const [showTextbox, setShowText] = useState(false)
  const [value, setValue] = useState(currentData?.content || data || '')

  useEffect(() => {
    value && !options.includes(value) && setShowText(true)
  }, [])

  const onSelect = (answer) => {
    if (identifier) {
      onValueForCoOwner(answer, identifier)
    } else if (answer === 'Other') {
      setShowText(true)
      setValue('')
    } else {
      onValue(answer)
    }
  }
  return (
    <View>
      {options.map((answer, index) => (
        <ListItem
          key={index}
          index={index}
          total={options.length}
          titleStyle={{ opacity: value === answer ? 1 : 0.5 }}
          style={{
            backgroundColor: value === answer && commonColors.highlighted,
          }}
          title={answer}
          onPress={() => onSelect(answer)}
        />
      ))}
      {showTextbox && (
        <InputText
          placeholder={otherTextLabel}
          style={{
            margin: 20,
            paddingTop: 0,
            textAlign: 'center',
            borderBottomWidth: 0.5,
          }}
          value={value}
          onChangeText={setValue}
        />
      )}
      <ButtonFlowNext
        containerStyle={{ marginTop: 40 }}
        disabled={
          (document?.type !== 'loan_application' && !value) ||
          (showTextbox && !value)
        }
        onPress={() => onValue(value)}
        document={document}
      />
    </View>
  )
}

export const FormInputSelectAndNavigateBranch = ({
  onValue,
  currentData,
  noButtons,
  list,
  document,
}) => {
  let nextForSelected
  return (
    <>
      <View style={{ alignItems: 'center' }}>
        {list.map(({ value, next }, index) => {
          if (currentData?.content === value) nextForSelected = next
          return (
            <ListItem
              key={index}
              index={index}
              total={list.length}
              title={value}
              titleStyle={{ opacity: currentData?.content === value ? 1 : 0.5 }}
              style={{
                backgroundColor:
                  currentData?.content === value && commonColors.highlighted,
                width: '100%',
              }}
              onPress={() => onValue(value, next)}
            />
          )
        })}
      </View>
      {!noButtons && (
        <ButtonFlowNext
          containerStyle={{ marginTop: 40 }}
          disabled={!currentData?.content}
          onPress={() => onValue(currentData?.content, nextForSelected)}
          document={document}
        />
      )}
    </>
  )
}
